// ! Opções dos dropdown do Cadastrar Contrato

const opSexo = [
    {
        label: 'Feminino',
        value: 'Feminino'
    },
    {
        label: 'Masculino',
        value: 'Masculino'
    }
];

const opCidadesZPETNExterno = [
    '2601409',
    '2614857',
    '2602902',
    '2607901',
    '2609402',
    '2605202',
    '2607208',
    '2600401',
    '2601508',
    '2604205',
    '2703502',
    '2607950',
    '2608206',
    '2608404',
    '2608701',
    '2609204',
    '2610004',
    '2611507',
    '2613305',
    '2616506',
    '2602308',
    '2605905',
    '2611804',
    '2611903',
    '2703007',
    '2703601',
    '2704302',
    '2704500',
    '2704708',
    '2707701',
    '2613404',
    '2614204',
    '2604007',
    '2604403',
    '2605400',
    '2606101',
    '2616308',
    '2616407',
    '2611606',
    '2600054',
    '2600609',
    '2600906',
    '2601201',
    '2601300',
    '2601706',
    '2601904',
    '2603454',
    '2604106',
    '2604502',
    '2606002',
    '2606408',
    '2606804',
    '2608909',
    '2609600',
    '2610608',
    '2610707',
    '2611200',
    '2611309',
    '2611408',
    '2613107',
    '2613701',
    '2614709',
    '2616001'
];

const opMensalidadePrime = [
    {
        label: 'Mensal',
        value: 'M'
    },
    {
        label: 'Anual',
        value: 'A'
    },
    {
        label: '4 Anos',
        value: 'AT'
    }
];

const opMensalidade = [{
    label: 'Mensal',
    value: 'M'
}];

const opCarencia = [
    {
        label: '72 horas',
        value: 3
    },
    {
        label: '30 dias',
        value: 30
    },
    {
        label: '45 dias',
        value: 45
    },
    {
        label: '60 dias',
        value: 60
    },
    {
        label: '90 dias',
        value: 90
    },
    {
        label: '120 dias',
        value: 120
    },
    {
        label: '150 dias',
        value: 150
    },
    {
        label: '180 dias',
        value: 180
    }
];

const opPromocional = [
    {
        label: 'Sim',
        value: true
    },
    {
        label: 'Não',
        value: false
    }
];

const opPagamento = [
    {
        label: 'Boleto',
        value: 1
    },
    {
        label: 'Cobrança recorrente - Cartão',
        value: 7
    }
];

const opPagamentoPrime = [
    {
        label: 'Boleto',
        value: 1
    },
    {
        label: 'Cobrança recorrente - Cartão',
        value: 7
    },
    {
        label: 'Débito em Conta',
        value: 5
    }
];

const opPagamentoParaES = [
    {
        label: 'Boleto',
        value: 1
    },
    {
        label: 'Cobrança recorrente - Cartão',
        value: 7
    },
    {
        label: 'EDP ESCELSA - Conta de Luz',
        value: 8
    }
];
const opPagamentoParaESPrime = [
    {
        label: 'Boleto',
        value: 1
    },
    {
        label: 'Débito em Conta',
        value: 5
    },
    {
        label: 'Cobrança recorrente - Cartão',
        value: 7
    },
    {
        label: 'EDP ESCELSA - Conta de Luz',
        value: 8
    }
];

const opPagamentoParaESSemBoleto = [
    {
        label: 'Cobrança recorrente - Cartão',
        value: 7
    },
    {
        label: 'EDP ESCELSA - Conta de Luz',
        value: 8
    }
];

const opTipoVenda = [
    {
        label: 'Venda de Contrato',
        value: 'VENDA'
    },
    {
        label: 'Troca de Plano',
        value: 'TROCA'
    },
    {
        label: 'Reabilitação de Contrato',
        value: 'REAB'
    }
];

const items = [{ label: 'Associado' }, { label: 'Dependentes' }, { label: 'Serviços Adicionais' }, { label: 'Checkout' }];

const itemsDocumento = [
    { label: 'Associado' },
    { label: 'Upload Arquivos' },
    { label: 'Dependentes' },
    { label: 'Serviços Adicionais' },
    { label: 'Checkout' }
];

export {
    opSexo,
    opMensalidadePrime,
    opCarencia,
    opPromocional,
    opCidadesZPETNExterno,
    opMensalidade,
    opPagamento,
    opPagamentoPrime,
    opPagamentoParaES,
    opPagamentoParaESPrime,
    opPagamentoParaESSemBoleto,
    opTipoVenda,
    items,
    itemsDocumento
};
